import { Injectable, inject } from '@angular/core';
import { PersistedModalName } from '@app/shared/models/modal.model';
import { TesterRepository } from '@app/shared/state/tester/tester.repository';
import { EventManager } from '@app/shared/utils/event-manager';

@Injectable({ providedIn: 'root' })
export class ModalBlocker {
  private readonly testerRepository = inject(TesterRepository);
  private readonly eventManager = inject(EventManager);

  blockModals(modals: PersistedModalName[]): void {
    if (!Array.isArray(modals)) {
      console.error('[ModalBlocker] Invalid Input, expected array');
      return;
    }

    if (modals.length === 0) {
      console.warn('[ModalBlocker] Empty array, no changes applied');
      return;
    }

    this.testerRepository.setBlockedModals(modals);

    console.info('[ModalBlocker] Blocked Modals:', modals.join(', '));
  }

  unblockModals(modals: PersistedModalName[]): void {
    const currentBlockedModals = this.testerRepository.getBlockedModals();
    const filteredModals = currentBlockedModals.filter((m) => !modals.includes(m));

    this.testerRepository.setBlockedModals(filteredModals);

    console.info('[ModalBlocker] Unblocked Modals:', filteredModals.join(', '));
  }

  blockAllModals(): void {
    const modals = Object.values(PersistedModalName).filter((v) => typeof v === 'number') as PersistedModalName[];

    this.testerRepository.setBlockedModals(modals);

    console.info('[ModalBlocker] Blocked Modals:', modals.join(', '));
  }

  getAllPersistedModals(): Record<PersistedModalName, string> {
    const persistedModals = {} as Record<PersistedModalName, string>;

    for (const key in PersistedModalName) {
      const numericKey = Number(key);
      if (!Number.isNaN(numericKey)) {
        persistedModals[numericKey as PersistedModalName] = PersistedModalName[numericKey] as string;
      }
    }

    return persistedModals;
  }

  clearBlockedModals(): void {
    this.testerRepository.setBlockedModals([]);
    console.info('[ModalBlocker] Unblocked ALL Modals');
  }

  closeAllModals(): void {
    this.eventManager.closeAllModals();
    console.info('[ModalBlocker] Closed ALL Modals');
  }
}
